// extracted by mini-css-extract-plugin
export default {"licenceSponsor":"Credits-module--licenceSponsor--3b3d3","translation":"Credits-module--translation--c6f2f"};